import { STATIC_URL } from '../../api/urls'
import Button from '@mui/material/Button'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import BackNavButton from '../common/BackNavButton'

interface Props {
  title?: string
  description?: string
  address: string
}

export default function AttachmentHeader({
  title = 'عنوان',
  description = 'توضیحات ضمیمه',
  address,
}: Props) {
  return (
    <Stack direction="row" justifyContent="space-between" sx={{ pl: { xs: 1, md: 2 } }}>
      <Box>
        <Typography fontSize="x-large" fontWeight="normal">
          {title}
        </Typography>
        <Typography fontSize="small" color="text.secondary">
          {description}
        </Typography>
      </Box>
      <Stack direction="row" gap={{ xs: 1, md: 2 }}>
        {address && (
          <Box>
            <Button
              variant="text"
              href={STATIC_URL + address}
              sx={{ display: { xs: 'none', md: 'inline-flex' }, mt: 0.5 }}
              startIcon={<DownloadIcon sx={{ color: 'primary' }} />}
            >
              دانلود
            </Button>
            <IconButton
              color="primary"
              href={STATIC_URL + address}
              sx={{ display: { md: 'none' } }}
            >
              <DownloadIcon sx={{ color: 'primary' }} />
            </IconButton>
          </Box>
        )}
        <Box>
          <BackNavButton />
        </Box>
      </Stack>
    </Stack>
  )
}
